import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import EnhancedTableHead from '../../../components/DataTables/TableHead';
import useStyles from './styles';
import { useTheme } from '@mui/material/styles';
import classNames from 'classnames';
import { Strings } from '../../../utils/strings';
import {
  applySortFilter,
  getComparator,
  getErrorMessage,
  secondaryTableCell,
  tableCell,
} from '../../../utils/appUtils';
import TableToolbox from '../../../components/TableToolbox';
import CustomizedTooltips from '../../../components/CustomizedTooltips';
import { useNavigate } from 'react-router-dom';
import NewJobForm from './NewJobForm';
import { connect } from 'react-redux';
import { fetchJobFormsList } from '../../../redux/actions/jobActions/jobActions/jobFormsList';
import { CircularProgress } from '@material-ui/core';
import moment from 'moment';
import { useAlert } from 'react-alert';
import { icons } from '../../../utils/icons';

const headCells = [
  { id: 'formName', label: 'TITLE', isSort: true },
  { id: 'createdAt', label: 'DATE', isSort: true },
  // { id: 'formCategory', label: 'TYPE', isSort: true },
  { id: 'formStatus', label: 'STATUS', isSort: true },
  { id: '' },
];

const JobForm = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const alert = useAlert();
  const [jobFormDialog, setJobFormDialog] = useState(false);
  // const [jobForms, setJobForms] = useState([]);
  const jobForms = props.jobFormsListData || [];
  const [isEdit, setIsEdit] = useState(false);
  const [isCopyForm, setIsCopyForm] = useState(false);
  const [selectedForm, setSelectedForm] = useState({});
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');

  const onError = (err) => {
    const error = getErrorMessage(err);
    if (error) {
      alert.error(error);
    }
  };

  useEffect(() => {
    props.fetchJobFormsList((err) => onError(err));
  }, [props.addJobFormData, props.updateJobFormData]);

  // useEffect(() => {
  //   const data = props.jobFormsListData ? props.jobFormsListData : [];
  //   setJobForms(data);
  // }, [props.jobFormsListData]);

  const descendingComparator = (a, b, orderBy) => {
    let asceding = b[orderBy] < a[orderBy];
    let descding = b[orderBy] > a[orderBy];
    if (orderBy === 'formCategory') {
      asceding =
        b[orderBy]?.categoryName.toLowerCase() <
        a[orderBy]?.categoryName.toLowerCase();
      descding =
        b[orderBy]?.categoryName.toLowerCase() >
        a[orderBy]?.categoryName.toLowerCase();
    }
    if (asceding) return -1;
    if (descding) return 1;
    return 0;
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const filteredForms = applySortFilter(
    jobForms,
    getComparator(order, orderBy, descendingComparator)
  );

  return (
    <div className={classes.job_container}>
      <TableToolbox
        isBack
        isLabel
        isPrimaryButton
        labelText={Strings.FORM + 's'}
        primaryButtonText={Strings.NEW_FORM}
        onClickBack={() => navigate(-1)}
        onNewClick={() => setJobFormDialog(true)}
        // isSecondaryButton
        // secondaryButtonText={Strings.CATEGORY_TYPES}
        // secondaryButtonClick={() => navigate('/app/jobs/forms/categories')}
      />
      <div className={classes.list_container}>
        {props.jobFormsListLoading ? (
          <div className={classes.flexView}>
            <CircularProgress
              style={{
                color: theme.palette.background_button,
              }}
            />
          </div>
        ) : jobForms.length === 0 ? (
          <div className={classes.flexView}>
            <p className={classes.no_data_message}>{Strings.NO_DATA_FOUND}</p>
          </div>
        ) : (
          <TableContainer className='dataTable'>
            <Table sx={{ minWidth: 930 }} aria-labelledby='tableTitle'>
              <EnhancedTableHead
                headCells={headCells}
                handleRequestSort={handleRequestSort}
                order={order}
                orderBy={orderBy}
              />
              <TableBody>
                {jobForms &&
                  filteredForms?.map((data, index) => {
                    const { formName, createdAt, formCategory, formStatus } =
                      data;
                    return (
                      <TableRow key={data._id} sx={{ width: '100%' }}>
                        <TableCell
                          style={{
                            ...tableCell(theme),
                          }}
                          component='td'
                          scope='row'
                        >
                          <Stack
                            paddingTop={2.5}
                            direction='row'
                            alignItems='center'
                          >
                            <label className={classes.name_cell}>
                              {formName}
                            </label>
                          </Stack>
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableCell(theme),
                          }}
                          component='td'
                          scope='row'
                        >
                          <Stack
                            paddingTop={2.5}
                            direction='column'
                            alignItems='flex-start'
                          >
                            <label className={classes.common_cell}>
                              {moment(createdAt).format('MMM D, YYYY')}
                            </label>
                          </Stack>
                        </TableCell>
                        {/* <TableCell
                          style={{
                            ...tableCell(theme),
                          }}
                          component='td'
                          scope='row'
                        >
                          <Stack
                            paddingTop={2.5}
                            direction='column'
                            alignItems='flex-start'
                          >
                            <label className={classes.common_cell}>
                              {formCategory?.categoryName}
                            </label>
                          </Stack>
                        </TableCell> */}
                        <TableCell
                          style={{
                            ...tableCell(theme),
                          }}
                          component='td'
                          scope='row'
                        >
                          <Stack
                            paddingTop={2.5}
                            direction='column'
                            alignItems='flex-start'
                          >
                            <label
                              className={classNames(
                                classes.common_cell,
                                classes.status_container,
                                formStatus === 'Active'
                                  ? classes.status_active
                                  : classes.status_inActive
                              )}
                            >
                              {formStatus}
                            </label>
                          </Stack>
                        </TableCell>
                        <TableCell
                          style={{ ...tableCell(theme) }}
                          component='td'
                          scope='row'
                        >
                          <Stack
                            paddingTop={2.5}
                            direction='row'
                            justifyContent='end'
                            alignItems='flex-start'
                          >
                            <CustomizedTooltips title={Strings.EDIT_JOB_FORM}>
                              <img
                                className={classes.action_icons}
                                src={icons(theme).editIcon}
                                alt=''
                                onClick={(e) => {
                                  setIsEdit(true);
                                  setSelectedForm(data);
                                  setJobFormDialog(true);
                                }}
                              />
                            </CustomizedTooltips>

                            <CustomizedTooltips title={Strings.COPY_FORM}>
                              <img
                                className={classes.action_icons}
                                style={{
                                  marginLeft: 15,
                                }}
                                src={icons(theme).copyIcon}
                                alt=''
                                onClick={(e) => {
                                  setIsCopyForm(true);
                                  setIsEdit(true); // we are using same edit form for copy form using isEdit & isCopyForm flag
                                  setSelectedForm(data);
                                  setJobFormDialog(true);
                                }}
                              />
                            </CustomizedTooltips>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
      {jobFormDialog && (
        <NewJobForm
          isEdit={isEdit}
          isCopyForm={isCopyForm}
          data={selectedForm}
          onClose={() => {
            setIsEdit(false);
            setIsCopyForm(false);
            setJobFormDialog(false);
          }}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  jobFormsListData: state.jobFormsListData.data,
  jobFormsListLoading: state.jobFormsListData.loading,

  addJobFormData: state.addJobFormData.data,

  updateJobFormData: state.updateJobFormData.data,
});

export default connect(mapStateToProps, {
  fetchJobFormsList,
})(JobForm);
